








































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { UserService } from '@/api'

@Component({})
export default class PasswordRestore extends Vue {
  public done = false
  public password = ''
  public restored = false
  public passwordNotEqual = false
  public password2 = ''

  public restore (): void {
    if (this.password !== this.password2) {
      this.passwordNotEqual = true
      return
    }

    this.passwordNotEqual = false

    const tokenRaw = this.$route.query.token

    let token = ''

    if (Array.isArray(tokenRaw)) {
      token = tokenRaw[0] ?? ''
    } else {
      token = tokenRaw
    }

    UserService.restoreUserPassword({ requestBody: { token: token, password: this.password } })
      .then((val) => {
        this.restored = val.restored
      })
      .finally(() => {
        this.done = true
      })
  }
}
